import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
`

export const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 2rem;

  @media (min-width: 768px) {
    padding: 3rem;
  }
`

export const Header = styled.header`
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
`

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #3182ce;
  font-size: 0.875rem;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1rem;
  transition: color 0.2s;

  &:hover {
    color: #2c5282;
  }
`

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
`

export const LastUpdated = styled.p`
  color: #718096;
  font-size: 0.875rem;
  margin: 0;
`

export const Section = styled.section`
  margin-bottom: 2rem;
`

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 1rem 0;
`

export const Paragraph = styled.p`
  color: #4a5568;
  line-height: 1.7;
  margin: 0 0 1rem 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const List = styled.ul`
  margin: 1rem 0;
  padding-left: 1.5rem;
`

export const ListItem = styled.li`
  color: #4a5568;
  line-height: 1.7;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const Footer = styled.footer`
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
  text-align: center;
`

export const HomeButton = styled.button`
  background: #3182ce;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #2c5282;
  }
`
